import { action } from 'satcheljs';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
const removeRecipientsFromRecipientWells = action(
    'removeRecipientsFromRecipientWells',
    (
        emailAddresses: EmailAddressWrapper[],
        recipientWells: RecipientWellWithFindControlViewState[]
    ) => ({
        emailAddresses,
        recipientWells,
    })
);
export default removeRecipientsFromRecipientWells;
